// Saisons automatiques : chaque thème s'active et se désactive selon la date,
// sans intervention. Pour prévisualiser hors saison : ajouter ?season=halloween ou ?season=noel à l'URL.
const SEASONS = {
  halloween: {
    id: "halloween",
    label: "Halloween",
    menuName: "Menu « Frisson »",
    menuKey: "brunch-halloween",
    path: "/brunch-halloween",
    until: "31 octobre",
    banner: "Édition Halloween jusqu'au 31 octobre",
    heading: ["Le brunch", "d'Halloween", " livré à domicile"],
    intro:
      "Le 31 octobre, la table se déguise : produits d'automne, présentation théâtrale, bonbons offerts pour les petits monstres. Tout arrive prêt à poser — vous n'avez qu'à allumer les citrouilles.",
    priceNote: "Dès 23,90 € / personne · livré le 30 ou 31 oct. et le 1er nov.",
    from: [10, 1],
    to: [11, 5],
  },
  noel: {
    id: "noel",
    label: "Noël",
    menuName: "Menu « Féerie »",
    menuKey: "brunch-noel",
    path: "/brunch-noel",
    until: "31 décembre",
    banner: "Brunch de Noël — livré du 20 au 31 décembre",
    heading: ["Le brunch", "de Noël", " livré à domicile"],
    intro:
      "Saumon fumé et blinis, œufs brouillés à la truffe, pain d'épices et bûche pâtissière : la magie de décembre arrive livrée à domicile, sans passer la veille en cuisine.",
    priceNote: "Dès 29,90 € / personne · livré du 20 au 31 décembre — réservez tôt",
    from: [12, 1],
    to: [12, 31],
  },
};

export function getSeason() {
  if (typeof window !== "undefined") {
    const forced = new URLSearchParams(window.location.search).get("season");
    if (forced && SEASONS[forced]) return SEASONS[forced];
  }
  const now = new Date();
  const md = (now.getMonth() + 1) * 100 + now.getDate();
  for (const s of Object.values(SEASONS)) {
    if (md >= s.from[0] * 100 + s.from[1] && md <= s.to[0] * 100 + s.to[1]) return s;
  }
  return null;
}

export { SEASONS };
